module.exports = __webpack_public_path__ + "img/Weapon_211.e075542d.png";